import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { FILE_EXTENSION } from 'src/app/utils/constants';
import { UPLOAD_ICON, DELETE_ICON } from 'src/app/utils/svgIcons';
import Swal from 'sweetalert2';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from "@angular/material/icon";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import * as XLSX from 'xlsx';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { encrypt, decrypt } from 'src/app/services/crypto-js.service';
import { getS3File, upload } from 'src/app/utils/s3';
import { environment } from 'src/environments/environment';
import { CarruselService } from 'src/app/services/carrusel.service';

@Component({
  selector: 'app-drop-zone',
  templateUrl: './drop-zone.component.html',
  styleUrls: ['./drop-zone.component.scss']
})
export class DropZoneComponent implements OnInit {
  @Output() employeesArrayList = new EventEmitter<any>();
  @Output() onUpdateSegmentation = new EventEmitter<boolean>();
  @Input() fileName: string;
  @Input() editingBanner: boolean;

  userData = JSON.parse(localStorage.getItem("usuario"));
  filesToUpload: any = [];
  arrayBuffer: any = [];
  jsonData : any = [];
  employeesList : any = [];
  notFoundModal: any = null

  constructor(
    private modalService: NgbModal,
    private ngxService: NgxUiLoaderService,
    private bannerService: CarruselService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer) {
      iconRegistry.addSvgIconLiteral('upload-icon', sanitizer.bypassSecurityTrustHtml(UPLOAD_ICON));
      iconRegistry.addSvgIconLiteral('delete-icon', sanitizer.bypassSecurityTrustHtml(DELETE_ICON));
    }

  ngOnInit(): void {
  }

  onDragOver(event: any) {
    event.stopPropagation();
    event.preventDefault();
  }

  async dropAttachFiles($event: any, notAllowedModal: any) {
    $event.preventDefault();
    const files = $event.dataTransfer ? $event.dataTransfer.files : $event.target.files;
    this.notFoundModal = notAllowedModal
    let file_name : string = ""

    for (let i = 0; i < files.length; i++) {
      file_name = files[i].name.split(/\.(?=[^\.]+$)/);
      const type = this.validateExtension(file_name[1]);
      if (type !== 'application/vnd.ms-excel') {
        const msgError = `Solo se permiten archivos formato Excel (.XLSM)`;
        return this.showAlert('Error al subir el archivo', msgError);
      }
      if (type) {
        if ((files[i].size * 0.000001) < 15) {
          this.readExcel($event.dataTransfer ? $event.dataTransfer.files[0] : $event.target.files[0])

        } else {
          const msg = `La longitud del archivo ${files[i].name} excede los límites permitidos. (15 MB)`;
          return this.showAlert('Error al subir el archivo', msg);
        }
      }
    }
  }

  readExcel(file: any) {
    try {
      this.ngxService.start();

      setTimeout(async ()=> {
        const readFilePromise = new Promise((resolve,reject)=>{
          const fileReader = new FileReader();
          fileReader.onload = e => {
            this.arrayBuffer = fileReader.result;
            const data = new Uint8Array(this.arrayBuffer);
            const arr = new Array();
            for (let i = 0; i !== data.length; i++){
              arr[i] = String.fromCharCode(data[i]);
            }
            const bstr = arr.join('');
            const workbook = XLSX.read(bstr,{type:'binary'});
            const first_sheet_name = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[first_sheet_name];

            resolve(XLSX.utils.sheet_to_json(worksheet,{raw:true}));
          };
          this.fileName = file.name;
          fileReader.readAsArrayBuffer(file);
        });
        this.jsonData = await readFilePromise;

        let response: any = await this.uploadFile(this.jsonData)
        console.log('response.key :>> ', response.key);
        let keyRoute: any = await this.validateEmployees(response.key)
        //let url: string = `ru-inasistencias/${keyRoute}`
        const jsonData: any = await getS3File(environment.AWS_CONFIG.validatorBucket, keyRoute);
        let stringData = new TextDecoder().decode(jsonData.Body);
        let employeeData = JSON.parse(stringData) 
        this.employeesList = employeeData

        if (this.editingBanner) { //BANDERA PARA ACTUALIZAR SEGMENTACION AL EDITAR
          this.onUpdateSegmentation.emit(true)
        }
        
        this.employeesArrayList.emit(employeeData)

        if (employeeData.allowed.length === 0 ) {
          this.cleanFile()
          this.ngxService.stop()
          return this.showAlert('Aviso', `No se encontraron registros validos.`)
        }

        this.ngxService.stop() 

      },500)

    } catch (error) {
      console.log(error);
      this.ngxService.stop()
      return this.showAlert('Error al subir el archivo', `Lo sentimos, hubo un problema al subir archivo, favor de volver a intentar.`)
    }
  }
  
  async uploadFile(json: any) {    
    let keys = Object.keys(json);
    const date = new Date();
    const formatDate = `${date.getFullYear()}/${date.getMonth()+1}/${date.getDate()}`

    if(keys.length > 1){
      let dataEmployees = [];
      json.forEach(element => {
        if(element["NO_EMPLEADO"]){
          dataEmployees.push({
            employee_id: element["NO_EMPLEADO"],
            fecha_inicio: null,
            fecha_fin: null
          })
        }
      });

      const text = `{"data": { "udn_id": "${this.userData.idCliente}", "employees": ${JSON.stringify(dataEmployees)} }}`;
      //const text = `{data:{udn:${this.userData.idCliente},employees:${JSON.stringify(dataEmployees)}}}` 
      const key = `red-unica/banner-carrusel/${formatDate}/employees${date.getTime()}.json`
      this.employeesList = `{"lista":{"empleados":${JSON.stringify(dataEmployees)}}}`
      const response = await upload(environment.AWS_CONFIG.bucket, key, text,'text/plain')
      return response
    }
    else {
      this.ngxService.stop()
      return this.showAlert('Algo salió mal', `El archivo no contiene ningún registro válido.`)
    } 
  }

  openModal(modalId: any){
    this.modalService.open(modalId, { size: 'lg' });
  }

  async validateEmployees(key: any[]) {
    try {
      let object = {
        data:{
          bucket: environment.AWS_CONFIG.bucket,
          file: key
        }
      }
      const encoded: any = await encrypt(object);
      const result:any = await this.bannerService.validateEmpleadosOld({ data: encoded.data})
      //const result:any = await this.bannerService.validateEmpleados({ data: encoded.data})
      const decoded: any = await decrypt({ data: result.data });
      let response: any = decoded.data

      if(response.code === 200) {
        return response.items[0].uri_file
      }

      this.ngxService.stop();
    } catch (error) {
      console.log('error')
      this.ngxService.stop();
      return this.showAlert('Algo salió mal', `Error al validar la información.`) 
    }
  }

  cleanFile() {
    this.fileName = null
    this.employeesArrayList.emit("");
  }

  showAlert(title:string ,message:string){
    Swal.fire({
      title: title,
      icon:  'info',
      text:  message,
      confirmButtonColor: '#545D6E',
      confirmButtonText: '<span style="color: #ffffff"> Entendido </span>',
    })
  }

  validateExtension(extension: string) {
    extension = extension.toLowerCase();
    if (extension === FILE_EXTENSION.JPEG || extension === FILE_EXTENSION.JPG || extension === FILE_EXTENSION.PNG) {
      return 'image/*';
    }
    if (extension === FILE_EXTENSION.PDF) {
      return 'application/pdf';
    }
    if (extension === FILE_EXTENSION.MP3) {
      return 'audio/*';
    }
    if (extension === FILE_EXTENSION.XLSX || extension === FILE_EXTENSION.XLSM) {
      return 'application/vnd.ms-excel';
    }
    if (extension === FILE_EXTENSION.MP4) {
      return 'video/mp4';
    } else {
      return false;
    }
  }

}